import React from "react";
import "./FourCardsSection.css";

const FourCardsSection = () => {
  return (
    <section className="fourcards-section">
      
      <div className="fourcards-wrapper">
        
        {/* Left Side Title + Description */}
        <div className="fourcards-left">
          <h2 className="fourcards-main-title">
            Who can take up this course?
          </h2>
        </div>

        {/* Right Side Cards */}
        <div className="fourcards-container">

          <div className="fourcard-box">
            <h3 className="fourcard-title">Aspiring Teachers</h3>
            <p className="fourcard-text">
              If you always wished or desired to be a teacher, you can take up this course.
            </p>
          </div>

          <div className="fourcard-box">
            <h3 className="fourcard-title">Corporate Jobs Switch</h3>
            <p className="fourcard-text">
              If you are working in a corporate & want Work-Life Balance, this teaching course is perfect.
            </p>
          </div>

          <div className="fourcard-box">
            <h3 className="fourcard-title">Home-makers</h3>
            <p className="fourcard-text">
              If you took a break from education or career to manage home, you can confidently restart here.
            </p>
          </div>

          <div className="fourcard-box">
            <h3 className="fourcard-title">Working Teachers</h3>
            <p className="fourcard-text">
              Already a teacher but need certification or want to upgrade skills? This course is for you.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default FourCardsSection;
